
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FadeInOutTransition } from '@shared/transitions/fade-in-out.transition';
import { PopupComponent } from '../popup/popup.component';

@Component({
    selector: 'menu-overlay',
    styleUrls: ['./menu-overlay.scss'],
    animations: [
        FadeInOutTransition(0.9, 500, 500)
    ],
    host: {
        "[@fadeInOutTransition]": ""
    },
    template: `
        <ng-container>
          @if (mainOverlayText && !secondOverlayText) {
            <app-popup (click)="onOverlayClicked()">
              <small [innerHTML]="mainOverlayText"></small>
            </app-popup>
          }
          @if (secondOverlayText && !mainOverlayText) {
            <app-popup>
              <small [innerHTML]="secondOverlayText"></small>
            </app-popup>
          }
          @if (mainOverlayText && secondOverlayText) {
            <app-popup class="dual" (click)="onOverlayClicked()">
              <small [innerHTML]="secondOverlayText"></small>
              <small [innerHTML]="mainOverlayText" class="font-medium"></small>
            </app-popup>
          }
        </ng-container>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PopupComponent]
})
export class MenuOverlayComponent {

	@Input() mainOverlayText: string | null;
	@Input() secondOverlayText: string | null;
	@Output() overlayClicked: EventEmitter<void> = new EventEmitter();

	onOverlayClicked() {
		this.overlayClicked.emit();
	}

}
